import React from "react";
import styles from "./CourseAccessRemovedBottomSheet.module.scss";
import Button from "@src/components/UIElements/Button";
import { Image } from "@src/components/Image";
import Modal from "@src/components/UIElements/Modal";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import * as actionCreator from "../../store/actions";
import { getAwsAssets } from "@src/utils";
import { useTranslation } from "react-i18next";
import RoundLockIcon from "../../../AccentIcons/RoundLockIcon";

const CourseAccessRemovedBottomSheet = ({
  mainText,
  subText,
  btnText,
  btnAction,
  goBackInstead,
  boldSubText,
  state = false,
  dispatcher = false,
  imageUrl,
  handleClose
}) => {
  const dispatch = useDispatch();
  const handleButtonClicked = () => {
    btnAction && btnAction();
  };

  return (
    <Modal showModal={state} handleClose={null} blockBackdrop={true}>
      <div className={styles.CourseLocked}>
        <div className={styles.CourseLocked__image}>
          <img src={imageUrl} />
        </div>
        <h1 className={styles.CourseLocked__heading}>{mainText}</h1>
        <p className={styles.CourseLocked__subtext}>
          {subText}
          {boldSubText && <span>{boldSubText}</span>}
        </p>
        <Button customClassName={styles.CourseLocked__customClassName} onClick={handleButtonClicked}>{btnText}</Button>
        {goBackInstead && <p className={styles.CourseLocked__viewAllInst} onClick={handleClose}>
          {goBackInstead}
        </p>}
      </div>
    </Modal>
  );
};

export default CourseAccessRemovedBottomSheet;
